import React from "react";
import { Typography } from "@material-tailwind/react";

export default function LoginForm({ formData, handleChange, handleSubmit, changeForm }) {
    return (
        <div className="w-full lg:w-3/5 mt-24">
            <div className="text-center">
                <Typography variant="h2" className="font-bold mb-4">INICIA SESIÓN</Typography>
                <Typography variant="paragraph" color="blue-gray" className="text-lg font-normal">
                    Ingresa tu usuario y contraseña para continuar.
                </Typography>
            </div>
            <form
                className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2"
                onSubmit={handleSubmit}
            >
                <div className="mb-1 flex flex-col gap-6">
                    <label htmlFor="username" className="-mb-3 font-medium text-blue-gray-700">
                        Usuario
                    </label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        className="border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-900"
                        autoComplete="username"
                        required
                    />
                    <Typography variant="small" color="blue-gray" className="-mb-3 font-medium">
                        Contraseña
                    </Typography>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-900"
                        placeholder="********"
                        autoComplete="current-password"
                        required
                    />
                </div>

                <div className="flex items-center mt-6 justify-end">
                    <input
                        type="checkbox"
                        id="remember_me"
                        name="remember_me"
                        checked={formData.remember_me}
                        onChange={handleChange}
                        className="mr-2"
                    />
                    <label htmlFor="remember_me" className="text-blue-gray-700">
                        Recuérdame
                    </label>
                </div>

                <button
                    type="submit"
                    className="mt-6 bg-black text-white py-2 px-4 rounded hover:shadow-lg font-sans uppercase w-full font-bold text-xs"
                >
                    Iniciar Sesión
                </button>

                <div className="flex items-center justify-center gap-2 mt-6">
                    <Typography variant="small" className="font-medium text-gray-900">
                        <a href="#" onClick={changeForm}>Olvidé mi contraseña</a>
                    </Typography>
                </div>
            </form>
        </div>
    );
}
